import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ProductService } from '../../../product.service';
import { PRODUCT_TTL_ES } from '../../../product.interface';
import { ICreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.interface';
import { CreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.template';

@Component({
  selector: 'pg-product-create',
  templateUrl: './product-create.component.html'
})
export class ProductCreateComponent
  extends CreateTemplate
  implements ICreateTemplate
{
  readyToCreate = false;
  select = {
    item: {
      type: 'single',
      openDialog: false,
      id: undefined
    },
    laboratory: {
      type: 'single',
      openDialog: false,
      id: undefined
    },
    unitMeasure: {
      type: 'single',
      openDialog: false,
      id: undefined
    }
  };

  constructor(private fb: FormBuilder, private productService: ProductService) {
    super(PRODUCT_TTL_ES, productService);
  }

  ngOnInit() {
    this.fg = this.fb.group({
      item: [{ value: '', disabled: true }, [Validators.required]],
      laboratory: [{ value: '', disabled: true }, [Validators.required]],
      unitMeasure: [{ value: '', disabled: true }, [Validators.required]]
    });
  }

  onSubmit() {
    if (this.readyToCreate) {
      this.createItem$(this.parseData());
    }
  }

  parseData() {
    return {
      itemId: this.select.item.id,
      unitMeasureId: this.select.unitMeasure.id,
      laboratoryId: this.select.laboratory.id
    };
  }

  onSelectedItem(row) {
    if (row) {
      this.select.item.id = row.id;
      this.fg.get('item').setValue(row.code + '-' + row.name);
      this.setReadyToCreate();
    }
    this.select.item.openDialog = false;
  }

  onSelectedLaboratory(row) {
    if (row) {
      this.select.laboratory.id = row.id;
      this.fg.get('laboratory').setValue(row.description);
      this.setReadyToCreate();
    }
    this.select.laboratory.openDialog = false;
  }

  onSelectedUnitMeasure(row) {
    if (row) {
      this.select.unitMeasure.id = row.id;
      this.fg.get('unitMeasure').setValue(row.description);
      this.setReadyToCreate();
    }
    this.select.unitMeasure.openDialog = false;
  }

  setReadyToCreate() {
    this.readyToCreate =
      this.select.laboratory.id &&
      this.select.unitMeasure.id &&
      this.select.item.id;
  }
}
